import 'modernizr';
import Nav from './components/component-nav';
import Modal from './components/component-modal';
import Marquee from './components/component-marquee';
import HoverInteraction from './components/component-hover-interaction';
import Typed from 'typed.js';
import ScrollTo from './components/component-scrollTo';
import { browser } from './utils/browsers';
import { logMixpanelEvent } from './utils/mixpanel';

const TYPED_CONST = {
  strings: ['business', 'office', 'event', 'school'],
  typeSpeed: 70,
  backSpeed: 50,
  smartBackspace: false,
  backDelay: 1200,
  loop: true,
};

document.body.classList.add(browser.name);

window.addEventListener('DOMContentLoaded', () => {
  // log page view event
  logMixpanelEvent('Page view');

  new Nav(document.getElementById('nav'));
  new Modal(document.getElementById('modal'));
  new HoverInteraction(document.querySelector('.section--steps'));
  new HoverInteraction(document.querySelector('.section--tools'), 768);
  new Marquee(document.querySelector('.section--screen-grid'));
  new Typed('.typed', TYPED_CONST);
  new ScrollTo(document.getElementById('navLogo'));
});
